export function splideSliders() {
    var check_home_slider = document.querySelector(".homepage-slider");

    if (check_home_slider) {
        new Splide(check_home_slider, {
            type: "fade",
            pagination: true,
            perPage: 1,
            arrows: false,
            height: "100vh",
            rewind: true,
            autoplay: true,
            pauseOnFocus: true,
            breakpoints: {
                767: {
                    height: "auto"
                }
            }
        }).mount();
    }

    var cardsImageSlides = document.querySelectorAll(".cards-slides.cards-image");
    var cardsContentSlides = document.querySelectorAll(
        ".cards-slides.cards-content"
    );

    if (cardsImageSlides) {
        for (var i = 0; i < cardsImageSlides.length; i++) {
            var cardsImageSlide = new Splide(cardsImageSlides[i], {
                type: "slide",
                perPage: 1,
                pagination: false,
                arrows: false,
                rewind: false,
                autoplay: false,
                updateOnMove: true,
                speed: 500,
                easing: "ease",
                lazyLoad: true,
            });

            var cardsContentSlide = new Splide(cardsContentSlides[i], {
                type: "fade",
                perPage: 1,
                pagination: false,
                arrows: true,
                isNavigation: true,
                rewind: false,
                autoplay: false,
            });

            cardsImageSlide.sync(cardsContentSlide);
            cardsImageSlide.mount();
            cardsContentSlide.mount();
        }
    }

    var defaultSlider = document.querySelectorAll(".default-slider");
    if (defaultSlider) {
        for (var i = 0; i < defaultSlider.length; i++) {
            var slide = new Splide(defaultSlider[i], {
                pagination: true,
                perPage: 3,
                gap: "24px",
                arrows: true,
                rewind: false,
                autoplay: false,
                pauseOnFocus: true,
                type: "carousel",
                lazyLoad: true,
                breakpoints: {
                    1064: {
                        perPage: 2,
                    },
                    767: {
                        perPage: 1,
                    },
                },
                lazyLoad: true,
            });

            var bar = slide.root.querySelector(".my-carousel-progress-bar");

            if (bar) {
                splide.on("mounted move", function () {
                    var end = splide.Components.Controller.getEnd() + 1;
                    var rate = Math.min((splide.index + 1) / end, 1);
                    bar.style.width = String(100 * rate) + "%";
                });
            }

            slide.mount();
        }
    }
}